import { BASE_NAME_APP } from '../config';

export const RESULTS = `${BASE_NAME_APP}/risultati`;
export const PAUSE = `${BASE_NAME_APP}/pausa`;
export const START_PAGE = `${BASE_NAME_APP}/inizia`;
export const HOMEWORK_EXECUTION = `${BASE_NAME_APP}/`;
export const SOLUTION_PAGE = `${BASE_NAME_APP}/soluzione`;
export const CORRECTION = `${BASE_NAME_APP}/correzione`;
export const CLASSWORK_LOGIN = '/prova';
export const CLASSWORK_LOGIN_CORRECTION = '/risultatiprova';
export const EXERCISE_CORRECTION = `${BASE_NAME_APP}/correzione-esercizio`;
export const ERROR = `${BASE_NAME_APP}/errore`;
export const OPEN_ASSIGNMENT = `${BASE_NAME_APP}/prova-assegnata`;
export const EXERCISE_PREVIEW = `${BASE_NAME_APP}/anteprima-esercizio`;
